import { render, staticRenderFns } from "./RecursiveMenu.vue?vue&type=template&id=e08f9582&scoped=true&"
import script from "./RecursiveMenu.vue?vue&type=script&lang=js&"
export * from "./RecursiveMenu.vue?vue&type=script&lang=js&"
import style0 from "./RecursiveMenu.vue?vue&type=style&index=0&id=e08f9582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08f9582",
  null
  
)

export default component.exports